<template>
  <div class="overlay">
    <!-- <div class="modal">
      <div class="modal__title">
        <span>Session Expired</span>
      </div>
      <div class="p-3">
        <p>You have left this browser idle for 10 minutes.</p>
        <p>{{ time }} second left</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import router from "@/router.js";
export default {
  data() {
    return {
      time: 1000,
    };
  },
  created() {
    let timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        localStorage.clear();
        router.push("/login");
      }
    }, 1000);
  },
};
</script>